module.exports = __webpack_public_path__ + "static/media/funnel_effect_mobile_en.82c91876.png";